<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="合同编号" name="code"></c-form-item>
					<c-form-item type="input" label="甲方单位" name="yzdw_name"></c-form-item>
					<c-form-item type="select" label="签署状态" name="qs_state" :options="contractStateList"></c-form-item>
				</c-form>
			</m-search>
			
			<c-table ref="table">
				<c-table-column
					label="签署状态"
					name="state"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="contractState[data.qs_state]" :style="{'color': contractState[data.qs_state].color}">{{contractState[data.qs_state].name}}</span>
					</template>
				</c-table-column>
					
				<c-table-column
					label="合同编号"
					name="code"
					width="130"
				></c-table-column>
					
				<c-table-column
					label="合同名称"
					name="name"
					width="180"
				></c-table-column>
				
				<c-table-column
					label="甲方单位"
					name="yzdw_name"
					width="270"
				></c-table-column>
				
				<c-table-column
					label="签约截止日"
					name="qy_last_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.qs_state == 2 && power('7')" @click="navigateTo('/transact/contract/detail', {id: data.id}, true)">签署</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/contract/detail', {id: data.id}, true)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
	</app>
</template>

<script>
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				dataList: []
			}
		},
		
		computed: {
			...mapState(['contractStateList']),
			...mapGetters(['power', 'contractState'])
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data) {
				this.$refs.table.load({
					url: '/project/ht/list',
					data
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
